module.exports = __webpack_public_path__ + "images/mail-success2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mail-success2.png
// module id = 1053
// module chunks = 17